import {Injectable, NgZone} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {DialpadComponent} from "../controls/dialpad/dialpad.component";
import {ActivatedRoute, Router} from "@angular/router";
import {SidenavService} from "./sidenav.service";
import {SettingsService} from "./settings.service";
import {hymnsDetailed} from "../hymn/hymnsDetailed";
import {LayoutService} from "./layout.service";
import {Hymn} from "../hymn/hymn";

@Injectable({
  providedIn: 'root'
})
export class HymnSelectionService {

  selectedHymn: Hymn = hymnsDetailed[0];
  dialpadActive = false;
  searchFocus: boolean = false;
  constructor(public dialog: MatDialog,
              private zone: NgZone,
              public router: Router,
              private sidenavService: SidenavService,
              private settingService: SettingsService,
              private layoutService: LayoutService) {
  }

  dialpad() {
    const dialogRef = this.dialog.open(DialpadComponent, {});
  }

  dialpadCancel() {
    this.dialpadActive = false;
    this.dialog.closeAll();
  }

  goToRandomHymn(favoritesOnly: boolean) {
    let result = this.selectedHymn?.hymnNumber;

    while (!result || result == this.selectedHymn?.hymnNumber) {
      if (favoritesOnly) {
        result = this.settingService.getFavorites()[Math.floor(Math.random() * this.settingService.getFavorites().length)].hymnNumber;
      }
      else {
        result = hymnsDetailed[Math.floor(Math.random() * hymnsDetailed.length)].hymnNumber;
      }
    }

    this.router.navigate(['/' + this.settingService.getHymnViewMode(), result + '']);
    if (this.layoutService.singleView) { this.sidenavService.closeList(); }
  }

  getRandomList(favoritesAndToLearnOnly: boolean, hasMidi: boolean = true): Hymn[] {
    // Return a random list of all hymns or all favorites and to learn hymns using a proper random algorithm
    let result: Hymn[] = [];
    let hymns = favoritesAndToLearnOnly ? [...this.settingService.getFavorites(), ...this.settingService.getHymnsToLearn()] : [...hymnsDetailed];
    let randomHymnNumbers = new Set<number>();
    return this.shuffleArray(hymns).filter(hymn => {
      return hymn.hasMidi;
    });
  }

  shuffleArray(array: any[]): any[] {
    for (let i = array.length - 1; i > 0; i--) {
      // Generate a random index from 0 to i
      const j = Math.floor(Math.random() * (i + 1));
      // Swap elements at indices i and j
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }
}
